
const initAccordion = () => {
  const accordions = document.querySelectorAll('.accordion');
  const accordionClassNameOpen = 'accordion_open';
  const closeAllAccordions = () => (
    accordions.forEach(accordion => {
      accordion.classList.remove(accordionClassNameOpen);
      accordion.querySelector('.accordion__content-wrapper').style.height = '0';
    })
  );

  accordions.forEach((accordion) => {
    const accordionHeader = accordion.querySelector('.accordion__header');
    const accordionContentWrapper = accordion.querySelector('.accordion__content-wrapper');
    const accordionContent = accordion.querySelector('.accordion__content');
    const openAcordion = () => {
      accordion.classList.add(accordionClassNameOpen);
      accordionContentWrapper.style.height = `${accordionContent.offsetHeight}px`;
    };

    if (accordion.hasAttribute('data-accordion-open')) {
      openAcordion();
    }

    accordionHeader?.addEventListener('click', () => {
      const isClosed = !accordion.classList.contains(accordionClassNameOpen);
      closeAllAccordions();

      if (isClosed) {
        openAcordion();
      }
    });
  });
}

initAccordion();

const atcWrapper = document.querySelector('#buy-button-block')
const stickyAtcWrapper = document.querySelector('.js-sticky-btn')
let options = {
  rootMargin: "0px",
};

const callbackAtcBtn = (entries, observer) => {
  entries.forEach((entrie) => {
    const chatBtn = document.getElementById('dummy-chat-button-iframe')

    if (entrie.isIntersecting) {
      stickyAtcWrapper.classList.add('jc-opacity-0', 'jc-invisible')

      if (chatBtn) chatBtn.style.zIndex = 200000;
    } else {
      stickyAtcWrapper.classList.remove('jc-opacity-0', 'jc-invisible')
      if (chatBtn) chatBtn.style.zIndex = -1;
    }
  });
};

const observerBtnAtc = new IntersectionObserver(callbackAtcBtn, options);

observerBtnAtc.observe(atcWrapper);

class VariantChange extends HTMLElement {
  constructor() {
    super();

    this.elements = {
      sizesModal: this.querySelector('.jc-btn-modal'),
      variants: this.querySelectorAll('.js-variants-update'),
      variantsJSON: this.querySelector('[data-product-variants-json]'),
      sectionId: 'ajax-jolly-main-product-info',
    };
  }

  async updateProductInfo(productHandle, currentVariantId, sectionId) {
    try {
      const response = await fetch(`${window.Shopify.routes.root}products/${productHandle}?variant=${currentVariantId}&section_id=${sectionId}`);
      if (!response.ok) {
        throw new Error(`Failed to fetch product: ${response.statusText}`);
      }

      const data = await response.text();
      const parser = new DOMParser();
      const parsedData = parser.parseFromString(data, "text/html");

      const oldVariantsBlock = document.querySelector(`#jolly-product-variants`);
      const newVariantsHtml = parsedData.querySelector(`#jolly-product-variants`)?.innerHTML;

      const oldPriceBlock = document.querySelector(`#js-main-product-price`);
      const newPriceHtml = parsedData.querySelector(`#js-main-product-price`)?.innerHTML;

      const oldBuyButonBlock = document.querySelector(`#buy-button-block`);
      const newBuyButonHtml = parsedData.querySelector(`#buy-button-block`)?.innerHTML;


      const oldStickyAtc = document.querySelector(`#js-main-product-sticky-atc`);
      const newStickyAtc = parsedData.querySelector(`#js-main-product-sticky-atc`)?.innerHTML;



      oldPriceBlock.innerHTML = newPriceHtml;
      oldVariantsBlock.innerHTML = newVariantsHtml;
      oldBuyButonBlock.innerHTML = newBuyButonHtml;
      oldStickyAtc.innerHTML = newStickyAtc;
    } catch (error) {
      console.error(`An error occurred: ${error}`);
    }
  }

  connectedCallback() {

    let currentVariantId = '';
    
    this.elements.variants.forEach(element => {
      element.addEventListener('click', async () => {
        const parsedVariantsJSON = JSON.parse(this.elements.variantsJSON.textContent);
        const checkedInputs = this.querySelectorAll('.js-variants-update:checked');
        let checkedOption = [];

        checkedInputs.forEach(input => {
          checkedOption.push(input.value);
        });

        const currentVariant = parsedVariantsJSON.filter(variant => variant.options.join(',') === checkedOption.join(','))[0];
        console.log(parsedVariantsJSON.filter(variant => variant.options.join(',') === checkedOption.join(',')));
        
        const productHandle = this.dataset.productHandle;
        currentVariantId = currentVariant.id;

        this.updateURLWithVariant(currentVariantId);

        const sectionId = this.elements.sectionId;
        let currentMedia;

        if (currentVariant.featured_media) {
          currentMedia = currentVariant.featured_media.id;

          if (element.classList.contains('js-input-color')) {
            let activeMediaSlide = document.querySelector(`[data-media-id="${currentMedia}"]`);
            let allMediaItems = document.querySelectorAll(`[data-media-id]`);
            let slideIndex = parseInt(Array.prototype.indexOf.call(allMediaItems, activeMediaSlide));

            const slideFound = new CustomEvent("galleryActiveSlide", {
              detail: {
                name: slideIndex,
              },
            });

            document.dispatchEvent(slideFound);
          }
        }

        await this.updateProductInfo(productHandle, currentVariantId, sectionId);
      });
    });

    document.querySelector('.product-size-modal').addEventListener('click', () => {
      document.querySelector(`#modals`).classList.toggle('is-open');
    })
  }
  
  updateURLWithVariant(variantId) {
    if (!variantId) return;

    const url = new URL(window.location.href);
    url.searchParams.set('variant', variantId);

    window.history.replaceState(
      { variantId },
      '',
      url.toString()
    );
  }

}

customElements.define('product-variant-picker', VariantChange);


const stickyElement = document.querySelector('.jc-product-sidebar-content');
const startPosition = stickyElement.getBoundingClientRect().top;

//Varibles
var endScroll = window.innerHeight - stickyElement.offsetHeight - 500,
  currPos = window.scrollY,
  screenHeight = window.innerHeight,
  stickyElementHeight = stickyElement.offsetHeight;
let topGap = 0, bottomGap = 0;

//Set Gaps
setTimeout(() => {
  if (stickyElement.hasAttribute(`data-top-gap`)) {
    const dataTopGap = stickyElement.getAttribute(`data-top-gap`);
    topGap = String(dataTopGap) == 'auto' ? startPosition : parseInt(dataTopGap);
  }

  if (stickyElement.hasAttribute(`data-bottom-gap`)) {
    bottomGap = parseInt(stickyElement.getAttribute(`data-bottom-gap`));
  }
}, 100);

//Add required style to sticky element
stickyElement.style.position = `sticky`;
stickyElement.style.top = topGap + `px`;
stickyElement.style.height = 'fit-content';

//Main function
function positionStickySidebar() {
  endScroll = window.innerHeight - stickyElement.offsetHeight - bottomGap;
  let stickyElementTop = parseInt(stickyElement.style.top.replace(`px;`, ``));
  if (stickyElementHeight + topGap + bottomGap > screenHeight) {
    if (window.scrollY < currPos) {
      //Scroll up
      if (stickyElementTop < topGap) {
        stickyElement.style.top = stickyElementTop + currPos - window.scrollY + `px`;
      } else if (stickyElementTop >= topGap && stickyElementTop != topGap) {
        stickyElement.style.top = topGap + `px`;
      }
    } else {
      //Scroll down
      if (stickyElementTop > endScroll) {
        stickyElement.style.top = stickyElementTop + currPos - window.scrollY + `px`;
      } else if (stickyElementTop < endScroll && stickyElementTop != endScroll) {
        stickyElement.style.top = endScroll + `px`;
      }
    }
  } else {
    stickyElement.style.top = topGap + `px`;
  }
  currPos = window.scrollY;
}
function stickyElementToMe() {
  stickyElement.style.top = topGap + `px`;
}
function updateSticky() {
  screenHeight = window.innerHeight;
  stickyElementHeight = stickyElement.offsetHeight;
  positionStickySidebar();
}
setTimeout(() => {
  //Check heights of the viewport and the sticky element on window resize and reapply positioning
  window.addEventListener(`resize`, () => {
    currPos = window.scrollY;
    updateSticky();
  });
  //Follow the main function when scrolling
  document.addEventListener(`scroll`, updateSticky, {
    capture: true,
    passive: true,
  });
}, 1000);


document.addEventListener('DOMContentLoaded', () => {
  const KLAVIYO_SELECTOR = '#klaviyo-bis-button-container';
  const BTN_SELECTOR = '.btn-of-stock.klaviyo-bis-trigger';

  const applyVisibilityRules = () => {
    const klaviyoContainer = document.querySelector(KLAVIYO_SELECTOR);
    const outOfStockBtn = document.querySelector(BTN_SELECTOR);

    if (!klaviyoContainer || !outOfStockBtn) return;

    const styles = window.getComputedStyle(klaviyoContainer);
    const isVisible =
      styles.display !== 'none' &&
      styles.visibility !== 'hidden' &&
      styles.opacity !== '0';

    if (isVisible) {
      klaviyoContainer.style.setProperty('display', 'none', 'important');
      outOfStockBtn.style.setProperty('display', 'block', 'important');
    }
  };

  applyVisibilityRules();

  const observer = new MutationObserver(() => {
    applyVisibilityRules();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['style', 'class'],
  });
});

